module.exports = __webpack_public_path__ + "static/media/IMG_4011-min.b5c4aa58.JPG";